module.exports = __webpack_public_path__ + "static/media/fixed-voice-success.f4f8a6a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-success.svg
// module id = 3183
// module chunks = 0